import { IConfig } from '@cian/config/shared';
import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';
import { UnknownError } from '@cian/peperrors';

import { fetchGetUserData, TGetUserDataResponse } from '../../repositories/users/v1/get-user-data';
import { TUser } from '../../types/currentUser';

type TRequestError = UnknownError & { statusCode?: number };

interface IDependencies {
  config: IConfig;
  httpApi: IHttpApi;
  logger: ILogger;
  cookie?: string;
  subdomain?: string;
}

export async function resolveUser({ cookie, httpApi, logger }: IDependencies): Promise<TUser> {
  try {
    const result = (await fetchGetUserData({
      httpApi,
      config: cookie ? { requestConfig: { headers: [['cookie', cookie]] } } : undefined,
    })) as TGetUserDataResponse;

    const userData = result.response?.user;

    if (!userData || !userData.cianUserId || !userData.realtyUserId) {
      return null;
    }

    return {
      cianUserId: userData.cianUserId,
      realtyUserId: userData.realtyUserId,
      phoneConfirmed: userData.phoneConfirmed,
      phone: userData.phone ?? undefined,
      email: userData.email ?? undefined,
      firstName: userData.firstName ?? undefined,
      lastName: userData.lastName ?? undefined,
      displayName: userData.displayName ?? undefined,
    };
  } catch (error) {
    const requestError = error as TRequestError;

    if (requestError.statusCode === 400) {
      return null;
    }

    logger.warning(requestError, {
      comment: '[Degradation] Нет информации о пользователе, пользователь считается неавторизованным',
    });

    return null;
  }
}
